import { useState, useCallback } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Plus } from 'lucide-react'
import { columns } from './columns'
import { DataTable } from './data-table'
import { useAdSupplierUsers } from '@/hooks/useAdSupplierUsers'
import { Skeleton } from '@/components/ui/skeleton'
import { AdSupplierUserDialog } from './AdSupplierUserDialog'
import { useViewMode } from '@/stores/viewMode'

export default function AdSupplierUsersPage() {
  const { id: supplierId } = useViewMode()

  const [page] = useState(1)
  const [pageSize] = useState(10)
  const [account, setAccount] = useState('')
  const [showAddDialog, setShowAddDialog] = useState(false)

  const { users, isLoading, isError, mutate } = useAdSupplierUsers({
    page,
    pageSize,
    supplier_id: supplierId,
    account,
  })

  const handleSearch = useCallback((value: string) => {
    setAccount(value)
  }, [])

  if (isError) {
    return (
      <div>
        <div className="text-center text-destructive">載入供應商使用者列表失敗。請稍後再試。</div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div>
        <Skeleton className="h-8 w-[200px] mb-4" />
        <Skeleton className="h-[400px] w-full" />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">供應商使用者管理</h2>
          <p className="text-muted-foreground mt-2">管理供應商使用者帳號</p>
        </div>
        <Button onClick={() => setShowAddDialog(true)}>
          <Plus className="mr-2 h-4 w-4" />
          新增供應商使用者
        </Button>
      </div>

      <Card>
        <CardContent className="p-6">
          <DataTable
            columns={columns}
            data={users || []}
            onSearch={handleSearch}
            meta={{
              reloadData: () => mutate(),
            }}
          />
        </CardContent>
      </Card>

      <AdSupplierUserDialog
        open={showAddDialog}
        onOpenChange={setShowAddDialog}
        supplierId={supplierId}
        onSuccess={() => mutate()}
      />
    </div>
  )
}
